import { withDisablePortal } from '@hapana/shared/utils/material-ui.util'

/** @type {MuiComponents['MuiDialog']} */
const overwrite = {}

export const MuiDialog = withDisablePortal(overwrite)
